/**
 * The one set of options for `onboarding.getCustomizerColours` (BLU-1399).
 * The Product sync Customizer section header and `CustomizerColourCodes` both
 * use it, so they read ONE cache entry: 60 s cache, no focus refetch, no poll.
 * A `.ts` module so the react-refresh lint rule stays quiet.
 */
export const CUSTOMIZER_COLOURS_QUERY_OPTIONS = { staleTime: 60_000, refetchOnWindowFocus: false } as const;
